<template>
  <div class="row home m-0">
    <div class="col-md-12">
      <div class="row h-100 d-flex align-items-center homeWrap">
        <div class="row">
          <div class="col-md-1">
          </div>
          <div class="col-md-2 col-xs-12">
            <MagLogo></MagLogo>
          </div>
          <div class="col-md-6">
          </div>
          <div class="col-md-3">
<!--            <p>-->
<!--              Vermont Primary Election<br />-->
<!--              Date: Tuesday, August 13, 2024-->
<!--            </p>-->
            <img class="rounded mx-auto d-block" src="../assets/Picture1.png">
            <p class="text-center"><b>Representing The Needs Of The NEK</b></p>

            <p class="text-center">
              The 2026 Legislative Session Begins on January 6, 2026<br />
              Vermont General Election - November 3, 2026
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
          </div>

          <div class="col-md-6  text-center">
            <h1>
              Vermont State Representative John Kascenska Representing <br />
              the Essex-Caledonia District Towns of
              <h6>Bloomfield, Brunswick, Burke, East Haven, Ferdinand, Granby, Guildhall, Lunenburg, Maidstone, Victory</h6>
            </h1>
          </div>
          <div class="col-md-3"></div>
        </div>
        <div class="row">
          <div class="col-md-12">
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 text-center">
            <ul class="list-inline custom-bullet-list">
              <li class="list-inline-item">House Committee on Appropriations</li>
              <li class="list-inline-item">House Canvassing Committee</li>
              <li class="list-inline-item">Joint Carbon Emissions Reduction Committee</li>
            </ul>
            <ul class="list-inline custom-bullet-list">
              <li class="list-inline-item">Vermont National Guard and Military Affairs Caucus</li>
              <li class="list-inline-item">Rural Caucus</li>
              <li class="list-inline-item">Vermont Community Development Board</li>
            </ul>
            <a class="text-danger" href="mailto:jkascenska@leg.state.vt.us">jkascenska@leg.state.vt.us</a>
          </div>
        </div>
      </div>
<!--      <div class="row m-0">-->
<!--        <div class="col-md-12 m-0">-->
<!--          Test-->
<!--        </div>-->
<!--      </div>-->
    </div>
  </div>
<!--  <div class="row m-0">-->
<!--    <div class="col-md-12 bg-danger p-2 text-center">-->
<!--      <a class="btn btn-outline-light" href="#" role="button">Donate to Campaign coming soon!</a>-->
<!--    </div>-->
<!--  </div>-->
</template>

<script>
import MagLogo from '../components/MagLogo';


export default {
  name: "HomePlacard",
  components: {
    MagLogo,
  }
}
</script>

<style scoped>

.home {
  background-image: url("../assets/vermont-autumn-landscape-1446126956Zbs.jpg");
  background-attachment: fixed;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top;
  min-height: 90vh;
  color: white;
  font-variant: small-caps;
}
.homeWrap{
  min-height: 90vh;
  background: gray; /* older browsers */
  background: rgba(0,0,0,0.55); /* newer browsers */
  height: 100%;
}
.homeBody{
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
h1{
  margin: 0;
}

.custom-bullet-list .list-inline-item:not(:last-child)::after {
  content: '\2022'; /* Unicode for a bullet point */
  margin: 0 0 0 8px; /* Adjust spacing as needed */
}
</style>
